import React from 'react';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import { FDBox, FDPrimaryActionButton } from '@facet-wealth/design';
import { navigateToFunding } from 'Helpers/AccountFunding';
import { dataAttrs } from 'Helpers/Testing';

const useStyles = buildUseStyles('CompleteFundingButton', (() => ({
  root: {},
})));

const CompleteFundingButton = ({
  className,
  completed,
  resource,
}) => {
  const classes = useStyles();

  const handleAccountFundingOnClick = () => {
    if (completed) {
      return;
    }

    navigateToFunding(resource);
  };

  const label = completed ? 'Completed' : 'Fund Account';

  return (
    <FDBox
      className={classNames(classes.root, className)}
    >
      <FDPrimaryActionButton
        {...dataAttrs('fund-account-button')}
        label={label}
        size={'sm'}
        onClick={handleAccountFundingOnClick}
      />
    </FDBox>
  );
};

CompleteFundingButton.defaultProps = {
  className: '',
  completed: false,
};

CompleteFundingButton.propTypes = {
  className: PropTypes.string,
  completed: PropTypes.bool,
  resource: PropTypes.object.isRequired,
};

export default CompleteFundingButton;
